import { Link, useLocation } from "react-router-dom";
import { CalendarCheck, Phone } from "lucide-react";
import { useTranslation } from "react-i18next";

const MobileCallButton = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation("common");
  const contactPath = pathname.startsWith("/es") ? "/es/contact" : "/contact";

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-white/10 bg-[#07111f] shadow-[0_-8px_30px_rgba(0,0,0,0.22)] sm:hidden"
      aria-label={t("mobileCall.actionsLabel")}
    >
      <a
        href="tel:+13476131717"
        className="flex min-h-16 items-center justify-center gap-2 border-r border-white/10 px-3 text-sm font-bold text-white transition-colors hover:bg-white/5"
        aria-label={t("mobileCall.ariaLabel")}
      >
        <Phone className="h-4 w-4 text-brand-yellow" />
        {t("mobileCall.call")}
      </a>
      <Link
        to={contactPath}
        className="flex min-h-16 items-center justify-center gap-2 bg-brand-yellow px-3 text-center text-sm font-bold text-brand-yellow-foreground transition-colors hover:bg-brand-yellow/90"
      >
        <CalendarCheck className="h-4 w-4" />
        {t("mobileCall.request")}
      </Link>
    </nav>
  );
};

export default MobileCallButton;
